module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/PinusPumila/Kanagawa_PinusPumila_GFDL_RCP85_Mid.png";